// src/pages/CreateNotification.js
import React, { useState } from "react";
import "./CreateNotification.css";
import apiClient from "../utils/apiClient"; // ✅ centralized API client with JWT/session handling
import SessionHandler from "../components/SessionHandler"; // ✅ global session expiry modal

const CreateNotification = () => {
  const [subject, setSubject] = useState("");
  const [validUntil, setValidUntil] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // ✅ Today's date (yyyy-mm-dd)
  const today = new Date().toISOString().split("T")[0];

  // ✅ Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!subject.trim() || !validUntil) {
      setError("❌ Please fill in all required fields.");
      return;
    }

    try {
      const data = await apiClient("/notifications/", {
        method: "POST",
        body: JSON.stringify({
          subject,
          valid_until: validUntil,
        }),
      });

      if (!data) return; // handled globally if session expired

      setMessage("✅ Notification created successfully.");
      setError("");
      setSubject("");
      setValidUntil("");
    } catch (err) {
      console.error("Error creating notification:", err);
      setError("❌ Failed to create notification. Please try again.");
    }
  };

  return (
    <div className="notification-container">
      <h2>Create Notification</h2>

      <form className="notification-form" onSubmit={handleSubmit}>
        <div>
          <label>Subject:</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Valid Until:</label>
          <input
            type="date"
            value={validUntil}
            onChange={(e) => setValidUntil(e.target.value)}
            min={today}
            required
          />
        </div>

        <button type="submit">Create</button>
      </form>

      {message && <p className="notification-message success">{message}</p>}
      {error && <p className="notification-message error">{error}</p>}

      {/* ✅ Global Session Expiry Modal */}
      <SessionHandler />
    </div>
  );
};

export default CreateNotification;
